import _ from 'lodash'
import type {FunctionPropertyTypeMetadata} from '../../../../../metadata'
import type {MinMaxSize, MinMaxSizeType} from '@wix/document-services-types'
import type {CssValue} from '../../constants'
import {deserializeFunction, serializeFunction} from '../utils/function'

const MIN_MAX_SIZE_TYPE: MinMaxSizeType = 'MinMaxSize'
const MIN_MAX_FUNCTION_NAME: string = 'minmax'

const serialize = (
    val: any,
    {argsMetadata}: FunctionPropertyTypeMetadata,
    serializeValue: Function
): CssValue | undefined => {
    if (!_.isPlainObject(val)) {
        return undefined
    }

    const {type, min, max} = val

    if (type !== MIN_MAX_SIZE_TYPE || !min || !max) {
        return undefined
    }

    const serializedMin = serializeValue(min, argsMetadata.min.types)
    const serializedMax = serializeValue(max, argsMetadata.max.types)

    return serializeFunction({name: MIN_MAX_FUNCTION_NAME, args: [serializedMin, serializedMax]})
}

const deserialize = (
    rule: CssValue,
    {argsMetadata}: FunctionPropertyTypeMetadata,
    deserializeValue: Function
): MinMaxSize | undefined => {
    const func = deserializeFunction(rule)
    if (!func) {
        return undefined
    }

    const {name, args} = func

    if (name !== MIN_MAX_FUNCTION_NAME || args?.length !== 2) {
        return undefined
    }

    const min = deserializeValue(args[0], argsMetadata.min.types)
    const max = deserializeValue(args[1], argsMetadata.max.types)

    return {
        type: MIN_MAX_SIZE_TYPE,
        min,
        max
    }
}

export default {
    serialize,
    deserialize
}
